<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-04 19:27:45
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-15 11:37:08
-->
<template>
  <el-select
    class="select"
    v-bind="$attrs"
    v-model="name"
    :loading="false"
    filterable
    :remote="remote"
    :remote-method="remoteMethod"
    @change="change"
    @focus="focus"
    :placeholder="placeholder"
    :multiple="multiple"
    :multiple-limit="multipleLimit"
    :collapse-tags="collapseTags"
    v-loadMore="loadMore"
  >
    <template v-slot:prefix>
      <i class="el-icon-search ml-4 mt-8 yx-color-pure-1"></i>
    </template>
    <el-option
      v-for="item in list"
      :key="item.product_id"
      :value="item.product_id"
      :label="item.product_name"
      class="footer-option"
    >
      <product-box :item="item"></product-box>
    </el-option>
    <div class="align-center pt-8 pb-8 yx-color-text-secondary">
      {{ noMore ? '到底了~' : '加载中' }}
    </div>
  </el-select>
</template>
<script>
// import { talentList, teamTalentList } from "@/api/extenTecord";
import productBox from "@/views/common/productBox";
import { productList } from "@/api/shopManage";
export default {
  components: {
    productBox,
  },
  props: {
    placeholder: {
      type: String,
      default: "输入商品名称进行搜索",
    },
    platformId: {
      type: [Number, String],
      default: "",
    },
    isTeam: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    multipleLimit: {
      type: Number,
      default: 0,
    },
    collapseTags: {
      type: Boolean,
      default: false,
    },
    search_type: {
      type: String,
      default: "1",
    },
    options: {
      type: Array,
      default: () => [],
    },
    remote: {
      type: Boolean,
      default: false,
    },
    selectValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      name: this.selectValue,
      list: this.options,
      noMore: true,
      params: {
        page_index: 1,
        page_size: 10
      },
      total: 0,
      searchValue: ''
    };
  },
  computed: {},
  watch: {
    selectValue: {
      handler(to) {
        this.name = to;
      }
    },
    options: {
      handler(to) {
        this.list = to;
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    //远程搜索
    async remoteMethod(e) {
      this.searchValue = e
      this.reset()
      this.getShopList(e);
    },
    async focus() {
      if(!this.remote) return
      this.searchValue = ''
      this.reset()
      this.getShopList();
    },
    async getShopList(e = '', type = 0) {
      const { platformId: platform_id } = this;
      const { page= {}, list = [] } = await productList({ platform_id, ...this.params, product_name: e, view_self: 0, other_status: 1 },);
      this.total = page.item_total
      this.list = type ? this.list.concat(list) : list        
    },
    //选择达人
    change(e) {
      const obj = this.list.find((item) => item.product_id === e);
      this.$emit("input", e);
      this.$emit("change", e, obj);
    },
    loadMore() {
      let num = Math.ceil(this.total / this.params.page_size)
      if(num <= this.params.page_index) return this.noMore = true
      this.noMore = false
      this.params.page_index++;
      this.getShopList(this.searchValue, 1);
    },
    reset() {
      this.list = []
      this.params = {
        page_index: 1,
        page_size: 10
      }
    }
  },
};
</script>
<style lang="less" scoped>
.select {
  width: 100%;
}
.footer-option {
  padding: 16px;
  height: auto !important;
  line-height: initial;
  border-bottom: 1px solid #eaebf0;
}
.select {
  /deep/ .el-select__input {
    margin-left: 30px;
  }
}
</style>